// extracted by mini-css-extract-plugin
module.exports = {"container":"DatepickerCalendar_container_3XnvZ","content":"DatepickerCalendar_content_1wApj","palette":"DatepickerCalendar_palette_1xU1G"};